import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TravelerCategoryService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}


  get(){
    return this.http.get<any[]>(this.brennerSoftwareApiEndpoint + `travelerCategory/getList/`);
  }









}
